export const COMMITTED_SELL_DEAL = 'COMMITTED_SELL_DEAL';
